import {Injectable} from "@angular/core";
import {ConfigService} from "../config.service";
import {Router} from "@angular/router";
import {Usuario} from "../../../_types/Usuario";
import {APIService} from "../api.service";
import {Empresa} from "../../../_types/Empresa";
import {Core} from "../../../_types/Core";
import Swal from "sweetalert2";

@Injectable()
export class AuthService {

    user: Usuario;
    company: Empresa;
    availableCompanies: Empresa[];
    modules: Core.Menu[];

    constructor(private apiService: APIService, private config: ConfigService, private router: Router) {
        try {
            if (localStorage.getItem("user")) {
                this.populateUser(JSON.parse(localStorage.getItem("user")), JSON.parse(localStorage.getItem("menu")));
            }
            // tslint:disable-next-line:variable-name
        } catch (_ignored) {

        }
    }

    get isLoggedIn(): boolean {
        // TODO:
        return !!this.user;
        // Check if current date is before token
        // expiration and user is signed in locally
        // return false;
    }

    /**
     * Method that sets the "isLoggedIn" property, used to follow the pattern implemented previously
     */
    set isLoggedIn(isLoggedIn) {
    }

    changeCompany(empresa) {
        return this.apiService.post("moduloGeral/login/setEmpresa", {
            empresa: empresa.id
        })
            .then(() => {
                const user = JSON.parse(localStorage.getItem("user"));
                user.empresa = empresa;
                this.company = empresa;
                localStorage.setItem("user", JSON.stringify(user));
            });
    }

    populateUser(user: any, menu: any[]): void {
        this.user = user;
        this.company = user.empresa;
        this.availableCompanies = user.empresas;
        this.modules = menu;


        // @ts-ignore
        delete this.user.empresa;
        // @ts-ignore
        delete this.user.empresas;
    }

    async login(loginObj: any) {
        this.apiService.post("moduloGeral/login/login", {
            login: loginObj.email,
            senha: loginObj.password
        })
            .then((retorno: any) => {
                if(retorno.error)
                {
                    return Swal.fire(
                        "Erro!",
                        retorno.error,
                        "error");
                }

                localStorage.setItem("token", retorno.hashToken);
                localStorage.setItem("user", JSON.stringify(retorno.usuario));
                localStorage.setItem("menu", JSON.stringify(retorno.menu));
                this.populateUser(retorno.usuario, retorno.menu);
                this.isLoggedIn = true;
                this.router.navigate(["/"]);
            }, (error: any) => {
                console.error(error);

                localStorage.clear();
                sessionStorage.clear();
                this.isLoggedIn = false;

                this.router.navigate(["/login"])
                    .then(() => location.reload());

                return Promise.reject(error);
            });
    }

    logout() {
        this.apiService.post("moduloGeral/login/logout", {})
            .then(() => {
                localStorage.clear();
                sessionStorage.clear();

                delete this.user;
                delete this.company;
                delete this.availableCompanies;
                delete this.modules;
                return this.router.navigate(["/login"]).then(() => location.reload());
            });
    }

}
